// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderLogo_link_Gqz_O","logo":"HeaderLogo_logo_1rcPa"};